<div class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
  <div class="flex items-start gap-3 mb-4">
    <div class="w-1 h-8 bg-[#3D3DF4] rounded-full shrink-0"></div>
    <h2 class="text-lg font-bold text-gray-900 dark:text-white leading-tight">Últimos Chats</h2>
  </div>

  <div
    class="bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-[1.5rem] md:rounded-2xl overflow-hidden">
    @if (isLoading) {
    <div class="py-8 flex items-center justify-center">
      <app-loader label="Cargando chats..." size="md"></app-loader>
    </div>
    } @else if (chats.length === 0) {
    <div class="text-center py-8 text-gray-500 dark:text-gray-400">No hay chats recientes.</div>
    } @else {
    <div class="overflow-x-auto w-full hidden md:block">
      <table class="w-full table-auto">
        <thead>
          <tr
            class="bg-[#F9FAFB] dark:bg-[var(--color-dark-bg-primary)] border-b border-gray-100 dark:border-gray-700">
            <th
              class="text-left text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 px-6">
              Pregunta
            </th>
            <th
              class="text-left text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 px-4">
              Agente
            </th>
            <th
              class="text-right text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 px-6">
              Fecha
            </th>
          </tr>
        </thead>
        <tbody>
          @for (chat of chats; track chat.key) {
          <tr
            class="border-b border-gray-50 dark:border-gray-800 last:border-0 hover:bg-gray-50 dark:hover:bg-gray-800/30 cursor-pointer transition-colors"
            (click)="onSelect(chat)">
            <td class="py-3.5 px-3 xl:px-6">
              <span class="text-sm text-gray-900 dark:text-white break-words w-full md:max-w-[240px] sm:max-w-none">
                {{ chat.question }}
              </span>
            </td>
            <td class="py-3.5 px-2 xl:px-4">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold"
                [ngClass]="chat.agentBadgeClasses">
                {{ chat.agentShortName }}
              </span>
            </td>
            <td class="py-3.5 px-3 xl:px-6 text-right">
              <span class="text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap">{{ chat.dateLabel }}</span>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="md:hidden flex flex-col p-3 space-y-3 bg-[#FAFBFF] dark:bg-transparent">
      @for (chat of chats; track chat.key) {
      <app-recent-chat-card [chat]="chat.raw" [question]="chat.question" [agentShortName]="chat.agentShortName"
        [agentBadgeClasses]="chat.agentBadgeClasses" [dateLabel]="chat.dateLabel" [onOpen]="openChat">
      </app-recent-chat-card>
      }
    </div>

    @if (totalCount > 0) {
    <div class="px-4 sm:px-6 py-3 border-t border-gray-100 dark:border-gray-700 text-center bg-white dark:bg-[var(--color-dark-bg-secondary)]">
      <a (click)="viewAllRequested.emit()"
        class="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-medium text-[#3D3DF4] dark:text-[#5D5DF6] hover:underline cursor-pointer md:px-0 md:py-0 md:rounded-none">
        Ver todos ({{ totalCount }})
      </a>
    </div>
    }
    }
  </div>
</div>
